import InvoiceAutomationRunChangeTypeEnum from './InvoiceAutomationRunChangeTypeEnum';

const InvoiceAutomationRunChangeTypeOptionsArray = [
  { label: 'Draft created', value: InvoiceAutomationRunChangeTypeEnum.DraftCreated },
  { label: 'Draft made again', value: InvoiceAutomationRunChangeTypeEnum.DraftRecreated },
  { label: 'Job added', value: InvoiceAutomationRunChangeTypeEnum.JobAdded },
  { label: 'Late job moved to a later draft', value: InvoiceAutomationRunChangeTypeEnum.LateJobMoved },
  { label: 'Out-of-scope job brought in', value: InvoiceAutomationRunChangeTypeEnum.JobBroughtIn },
  { label: 'Job removed, no longer ready', value: InvoiceAutomationRunChangeTypeEnum.JobRemoved },
  { label: 'Job skipped', value: InvoiceAutomationRunChangeTypeEnum.JobSkipped },
  { label: 'Fulfillment date moved', value: InvoiceAutomationRunChangeTypeEnum.FulfillmentDateMoved },
];

export default InvoiceAutomationRunChangeTypeOptionsArray;
